const en = {
  translation: {
    //misc
    hello: "Hello",
    name: "Name",
    "full name": "Full Name",
    phone: "Phone",
    "phone number": "Phone Number",
    email: "Email",
    "email address": "Email Address",
    address: "Address",
    password: "Password",
    "password confirmation": "Password Confirmation",
    maintenance: "Maintenance",
    "view all": "View All",
    usd: "USD",
    "product description": "Product Description",
    "add to cart": "Add To Cart",
    "shipping fee": "Shipping Fee",
    "order Id": "Order ID",
    "paid by": "Paid By",
    date: "Date",
    order: "Order",
    "to ship": "To Ship",
    completed: "Completed",
    rejected: "Rejected",
    total: "Total",
    "direct downline": "direct downline",
    downline: "Downline",
    "sponsor genealogy": "Sponsor Genealogy",
    "placement genealogy": "Placement Genealogy",
    "click on username to view further downline if any":
      "Click on username to view further downline if any",
    search: "Search",
    "bonus summary": "bonus summary",
    "no items in the cart": "No items in the cart ",
    "add some": "Add Some",
    "proceed to checkout": "PROCEED TO CHECKOUT",
    subtotal: "Subtotal",
    tax: "Tax",
    "grand total": "Grand Total",
    loading: "Loading",
    "no products found": "No products found",
    update: "Update",
    //side menu
    "register account": "Register Account",
    "my profile": "My Profile",
    resource: "Resource",
    "repeat purchase": "Repeat Purchase",
    "my order": "My Order",
    cart: "Cart",
    policy: "Policy",
    "contact us": "Contact Us",
    "log out": "Log Out",
    //footer
    home: "Home",
    news: "News",
    community: "Community",
    wallet: "Wallet",
    //Breadcrumb
    back: "Back",
    //contact us
    "get in touch": "Get in touch",
    "Get in touch how you like, the choice is yours":
      "Get in touch how you like, the choice is yours",
    "drop us a line": "Drop us a line",
    "enter your name": "Enter Your Name",
    "enter email address": "Enter Email Address",
    subject: "Subject",
    "enter your subject": "Enter Your Subject",
    message: "Message",
    "enter your message": "Enter Your Message",
    submit: "Submit",
    //login
    "enter your password": "Enter Your Password",
    "don't have an account": "Don't have an account?",
    "register now": "Register Now",
    login: "Login",
    "please click here": "Please Click Here",
    //forget password
    "forget password": "Forget Password",
    username: "User name",
    "reset password": "Reset Password",
    //policy
    "term of use": "Term of Use",
    "privacy agreement": "Privacy Agreement",
    "refund and return agreement": "Refund and Return Agreement",
    "merchant service agreement": "Merchant Service Agreement",
    //register
    sponsor: "Sponsor",
    placement: "Placement",
    "placement position": "Placement Position",
    left: "Left",
    right: "Right",
    "nric/passport no": "NRIC/Passport No.",
    "address line 1": "Address line 1",
    "address line 2": "Address line 2",
    state: "State",
    postcode: "PostCode",
    city: "City",
    "minimum 8 characters, at least one uppercase letter, one lowercase letter, and one number":
      "Minimum 8 characters, at least one uppercase letter, one lowercase letter, and one number",
    "already have an account": "Already have an account",
    "sign in now": "Sign in Now",
    register: "Register",
    enter: "Enter",
    "enter your": "Enter Your",
    //profile
    profile: "Profile",
    "edit profile": "Edit Profile",
    "edit bank information": "Edit Bank Information",
    "change password": "Change Password",
    "change security password": "Change Security Password",
    "my address": "My Address",
    //Bank Name
    "bank name": "Bank Name",
    "bank holder name": "Bank Holder Name",
    "bank account": "Bank Account",
    "bank swift": "Bank Swift",
    "bank swift code": "Bank Swift Code",
    //password
    "for your account's security, do not share your password with anyone else":
      "For your account's security, do not share your password with anyone else",
    "current password": "Current Password",
    "new password": "New Password",
    "confirm password": "Confirm Password",
    confirm: "Confirm",
    // security password
    "current security password": "Current Security Password",
    "new security password": "New Security Password",
    "confirm security password": "Confirm Security Password",
    //address
    "add new address": "Add New Address",
    "delete address": "Delete Address",
    reset: "Reset",
    //product
    filter: "Filter",
    categories: "Categories",
    "buy now": "Buy Now",
    //wallet
    convert: "Convert",
    transfer: "Transfer",
    transaction: "Transaction",
    withdraw: "Withdraw",
    "withdrawal history": "Withdrawal History",
    "convertable balance": "Convertable Balance",
    "convert amount": "Convert Amount",
    "convert now": "Convert Now",
    amount: "Amount",
    "select wallet": "Select Wallet",
    "convert wallet": "Convert Wallet",
    remark: "Remark",
    "security password": "Security Password",
    "withdrawal now": "Withdrawal Now",
    "transferable balance": "Transferable Balance",
    "transaction history": "Transaction History",
    "no transaction history": "No Transaction History",
    "date & time": "Date & Time",
    "id & no.": "Id & No.",
    done: "Done",
    "withdrawable balance": "Withdrawable Balance",
    withdrawal: "Withdrawal",
    "withdraw charges": "Withdraw Charges",
    "amount withdrawal minimum 50, maximum 5000":
      "Amount Withdrawal Minimum 50, Maximum 5000",
    status: "Status",
    "charges fee": "Charges Fee",
    "bank info": "Bank Info",
    "no withdrawal history": "No Withdrawal History",
    "transfer to": "Transfer To",
    "transfer amount": "Transfer Amount",
    "transfer now": "Transfer Now",
    //schema
    "is required": "is required",
    "must be at least 8 characters": "must be at least 8 characters",
    "password must match": "password must match",
    "Password criteria 1":
      "Password must include at least one uppercase letter, one lowercase letter, and one number",
    "register member": "register member",
    file: "File",
    "not exists": "not exists",
    "Enter To": "Enter To",
  },
};

export default en;
